import RentersInsuranceLayout from '../../layouts/RentersInsuranceLayout';
import CoverageErrors from '../../components/CoverageErrors';

const CoverageErrorsContainer = () => {
  return (
    <RentersInsuranceLayout>
      <CoverageErrors />
    </RentersInsuranceLayout>
  );
};

export default CoverageErrorsContainer;
